import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { EoiService } from '../../services/eoi/eoi.service';
import { ErrorHandlerService } from '../../services/shared/error-handler.service';

@Component({
  selector: 'app-edit-eoi-customer-dialog',
  templateUrl: './edit-eoi-customer-dialog.component.html',
  styleUrls: ['./edit-eoi-customer-dialog.component.css']
})
export class EditEoiCustomerDialogComponent implements OnInit {
  @ViewChild('customerForm') customerForm: NgForm;

  edit_lead_data: any = {
    lead_name: '',
    lead_phone: '',
    lead_code: '',
    lead_phone_without_code: '',
    lead_home_phone: '',
    lead_home_code: '',
    lead_home_phone_without_code: '',
    lead_other_phone: '',
    lead_other_code: '',
    lead_other_phone_without_code: '',
    lead_email: '',
    lead_national_id: '',
    lead_nationality: '',
    lead_birthday: '',
    lead_address: '',
    lead_district: '',
    lead_arabic_name: '',
    lead_issue_date: '',
    lead_job_title: '',
    lead_workplace: '',
    lead_work_address: '',
    lead_fax_number: '',
    lead_marital_status: '',
    lead_phone_error: '',
    lead_home_phone_error: '',
    lead_other_phone_error: ''
  };

  dialogTitle: string = 'Edit Customer Info';
  eoiId: any;

  constructor(
    public dialogRef: MatDialogRef<EditEoiCustomerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eoiService: EoiService,
    private errorHandlerService: ErrorHandlerService
  ) {
    if (data) {
      this.eoiId = data.eoi_id;
      this.dialogTitle = data.title || 'Edit Customer Info';

      // Copy customer data to edit_lead_data
      if (data.customer) {
        this.edit_lead_data = { ...this.edit_lead_data, ...data.customer };

        // Handle phone fields separately if they exist
        if (data.customer.lead_phone && !data.customer.lead_phone_without_code) {
          this.extractPhoneComponents('lead_phone', data.customer.lead_phone);
        }
        if (data.customer.lead_home_phone && !data.customer.lead_home_phone_without_code) {
          this.extractPhoneComponents('lead_home_phone', data.customer.lead_home_phone);
        }
        if (data.customer.lead_other_phone && !data.customer.lead_other_phone_without_code) {
          this.extractPhoneComponents('lead_other_phone', data.customer.lead_other_phone);
        }
      }
    }
  }

  ngOnInit() {
  }

  private extractPhoneComponents(phoneField: string, fullPhone: string) {
    // Simplified extraction - adjust based on data format
    const phoneRegex = /^\+?(\d{1,3})\s?(.+)$/;
    const match = fullPhone.match(phoneRegex);

    if (match) {
      const codeField = phoneField.replace('phone', 'code');
      const withoutCodeField = phoneField + '_without_code';

      this.edit_lead_data[codeField] = '+' + match[1];
      this.edit_lead_data[withoutCodeField] = match[2].replace(/\s/g, '');
    }
  }

  receivePhone(event: any, phone: string, code: string, err: string) {
    this.edit_lead_data[err] = event.phoneError;
    this.edit_lead_data[phone] = event.phone;
    this.edit_lead_data[code] = event.code;
    console.log('Received phone:', event, this.edit_lead_data);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    // Validate phone fields
    if (this.edit_lead_data['lead_phone_error']) {
      swal('Invalid Primary Phone', this.edit_lead_data['lead_phone_error'] || 'Please enter a valid phone number', 'error');
      return;
    }

    if (this.edit_lead_data['lead_home_phone_error']) {
      swal('Invalid Home Phone', 'Please enter a valid home phone number', 'error');
      return;
    }

    if (this.edit_lead_data['lead_other_phone_error']) {
      swal('Invalid Other Phone', 'Please enter a valid other phone number', 'error');
      return;
    }

    // Validate required fields
    if (!this.edit_lead_data.lead_name) {
      swal('Required Field', 'Customer name is required', 'error');
      return;
    }

    if (!this.edit_lead_data.lead_address) {
      swal('Required Field', 'Customer address is required', 'error');
      return;
    }

    if (!this.edit_lead_data.lead_nationality) {
      swal('Required Field', 'Customer nationality is required', 'error');
      return;
    }

    if (!this.edit_lead_data.lead_national_id) {
      swal('Required Field', 'Customer national ID is required', 'error');
      return;
    }

    this.editLeadModalSubmit(this.edit_lead_data, this.dialogRef);
  }

  editLeadModalSubmit(lead, modal?) {
    let payload = { ...lead };

    // Remove error fields from payload
    delete payload.lead_phone_error;
    delete payload.lead_home_phone_error;
    delete payload.lead_other_phone_error;

    this.eoiService
      .editLeadInEoi(this.eoiId, payload)
      .subscribe(
        (res: any) => {
          swal("Success", "Customer information updated successfully", "success");
          modal.close(lead);
        },
        (err) => this.errorHandlerService.handleErorr(err)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/eois/dialogs/edit-eoi-customer-dialog.component.ts